"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _stylitas = require("@creditas/stylitas");

var _button = require("./button.style");

var Button = _stylitas.styled.button(_templateObject(), _button.buttonBase, _button.buttonIsLoading, _button.buttonSecondary, _button.buttonTertiary, _button.buttonFullWidth, _button.buttonIcon);

exports.Button = Button;